module.exports = __webpack_public_path__ + "img/Picto.6233101b.png";